export default "__VITE_ASSET__Dkr8lbXU__"